//#region types
import { CurrencyEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
import { ChartDataDisplayProps } from "models/propTypes/wintSalaryPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "components/common/icon";
//#endregion
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ChartDataDisplay: React.FC<ChartDataDisplayProps> = (props) => {
  const { title, value, deviationPercentage, deviationDescription, showDeviationIndicator } = props;

  const renderDescription = () => {
    if (deviationPercentage === undefined) {
      return undefined;
    }

    const formattedPercentage = LocalizationHelperInstance.getFormattedPercentage(
      deviationPercentage / 100,
      0,
      2,
      "always"
    );

    const text = UtilsHelper.isEmpty(deviationDescription)
      ? `${formattedPercentage}`
      : `${formattedPercentage} ${deviationDescription}`;

    if (!text) return undefined;

    const shouldShowIcon = showDeviationIndicator && deviationPercentage !== 0;
    if (!shouldShowIcon) {
      return text;
    }

    return (
      <>
        {text}{" "}
        <Icon
          icon={
            deviationPercentage > 0
              ? IconDefinitionConstants.WDropArrowUpSmall
              : IconDefinitionConstants.WDropArrowSmall
          }
        />
      </>
    );
  };

  return (
    <Grid item className={cssExports.chartDataDisplay}>
      <Grid item className={cssExports.title}>
        {title}
      </Grid>
      <Grid item container direction="row" alignItems="baseline" columnSpacing={1} wrap="nowrap">
        <Grid item className={cssExports.labelTextContent}>
          {LocalizationHelperInstance.getFormattedCurrency(
            value.amount ?? 0,
            value.currency ?? CurrencyEnums.CurrencyCode.SEK
          )}
        </Grid>
        <Grid item className={cssExports.labelTextLabel}>
          {renderDescription()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ChartDataDisplay;
